








import { Component, Vue } from "vue-property-decorator";
import ViewKanban from "../dynamickanban/ViewKanban.vue";

@Component({
  components: {
    ViewKanban,
  },
})
export default class ticketsKanban extends Vue {
  
}
